import { useParams, Navigate } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SectionHero from '@/components/feature/sections/SectionHero';
import SectionTrustBar from '@/components/feature/sections/SectionTrustBar';
import SectionContentOverview from '@/components/feature/sections/SectionContentOverview';
import SectionAIBlock from '@/components/feature/sections/SectionAIBlock';
import SectionProcess from '@/components/feature/sections/SectionProcess';
import SectionWhyChooseUs from '@/components/feature/sections/SectionWhyChooseUs';
import SectionServiceAreas from '@/components/feature/sections/SectionServiceAreas';
import SectionTestimonials from '@/components/feature/sections/SectionTestimonials';
import SectionFAQ from '@/components/feature/sections/SectionFAQ';
import SectionFinalCTA from '@/components/feature/sections/SectionFinalCTA';
import { SERVICES_DATA } from '@/mocks/services';

export default function ServicePage() {
  const { slug } = useParams<{ slug: string }>();
  const service = SERVICES_DATA.find(s => s.slug === slug);

  if (!service) return <Navigate to="/" replace />;

  return (
    <div className="font-sans">
      <Navbar />
      <main>
        {/* 1. Hero */}
        <SectionHero
          eyebrow={service.eyebrow}
          headline={service.h1}
          accentLine={service.accentLine}
          subheadline={service.subheadline}
          image={service.heroImage}
          imageAlt={service.name + ' - All Done Roofing LLC'}
          cta="Request a Free Estimate"
        />

        {/* 2. Trust Bar */}
        <SectionTrustBar />

        {/* 3. Service Overview */}
        <SectionContentOverview
          eyebrow={service.overview.eyebrow}
          title={service.overview.title}
          titleAccent={service.overview.titleAccent}
          paragraphs={service.overview.paragraphs}
          features={service.overview.features}
          image={service.overview.image}
          imageAlt={service.name}
        />

        {/* 4. AI Answer Block */}
        <SectionAIBlock
          heading={service.aiBlock.heading}
          headingAccent={service.aiBlock.headingAccent}
          paragraphs={service.aiBlock.paragraphs}
        />

        {/* 5. Process */}
        <SectionProcess />

        {/* 6. Why Choose Us */}
        <SectionWhyChooseUs />

        {/* 7. Service Areas */}
        <SectionServiceAreas />

        {/* 8. Testimonials */}
        <SectionTestimonials />

        {/* 9. FAQ */}
        <SectionFAQ
          faqs={service.faqs}
          subtitle={`Honest answers about our ${service.name.toLowerCase()} services, process, and what to expect.`}
        />

        {/* 10. Final CTA */}
        <SectionFinalCTA
          headline={service.finalCTA.headline}
          accentLine={service.finalCTA.accentLine}
          subheadline={service.finalCTA.subheadline}
          primaryCTA={service.finalCTA.primaryCTA}
          image={service.finalCTA.image}
        />
      </main>
      <Footer />
    </div>
  );
}
